"use client";
import React, {useState, useEffect} from "react";
import styles from "./page.module.css";
import RedeemRecordList from "./RedeemRecordList";
import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import {RedeemRecordInfo} from "@/Core/Redeem/redeemEntity";
import Util from "@/Master/Util";
import EventManager from "@/Fwk/EventManager";
import {gameConst} from "@/app/const/gameConst";

export default function RedeemRecordUI() {
    const [dataList, setDataList] = useState<RedeemRecordInfo[]>([]);
    const [dataListOk, setDataListOk] = useState(false);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [maxPage, setMaxPage] = useState(1);

    useEffect(() => {
        getNewRedeemRecord();
        EventManager.addOnEnterListener(onEnter);
        EventManager.addEventListener(gameConst.onUpdateList,onUpdateList);
        return () => {
            EventManager.removeOnEnterListener(onEnter);
            EventManager.removeEventListener(gameConst.onUpdateList,onUpdateList);
        }
    }, []);

    const onUpdateList = () => {
        getNewRedeemRecord();
    }

    const onEnter = () => {
        getNewRedeemRecord();
    }

    let isUpdating = false;

    const getNewRedeemRecord = () => {
        if (isUpdating)return;
        isUpdating = true;
        setDataListOk(false);
        RedeemManager.GetRedeemRecord(page, pageSize, (totalPage: number, result) => {
            setMaxPage(totalPage);
            if (result && result.length > 0) {
                setDataList(result);
                if (Util.isLog){
                    console.log('getNewRedeemRecord result',result)
                }
            }
            setDataListOk(true);
            isUpdating = false;
        });
    }

    return (
        <div className={styles.page}>
            <RedeemRecordList listData={dataList} dataListOk={dataListOk}
                              onUpdateData={getNewRedeemRecord}></RedeemRecordList>
        </div>
    )
}
